import * as Lucide from 'lucide-react'

import { icon } from './icon'

/*
 * This file contains icons from Lucide (https://lucide.dev)
 *
 * Full Icon list here https://lucide.dev/icons/
 *
 * To add a new Lucide icon:
 * 1. Export it using icon(), in alphabetical order, e.g., export const IconName = icon(Lucide.IconNameIcon)
 * 2. The icon will automatically inherit Buffer's styling system
 * 3. Add it to the "Lucide Used [Do Not Export]" frame in the Figma icon file
 *
 * For custom icons (not from Lucide), see the "Adding an icon" guide in src/components/icons/Icons.mdx
 * (the Icons page in Storybook)
 */

export const ActivityIcon = icon(Lucide.ActivityIcon)
export const ArrowDownIcon = icon(Lucide.ArrowDownIcon)
export const ArrowDownUpIcon = icon(Lucide.ArrowDownUpIcon)
export const ArrowLeftIcon = icon(Lucide.ArrowLeftIcon)
export const ArrowLeftRightIcon = icon(Lucide.ArrowLeftRightIcon)
export const ArrowRightIcon = icon(Lucide.ArrowRightIcon)
export const ArrowUpIcon = icon(Lucide.ArrowUpIcon)
export const ArrowUpRightIcon = icon(Lucide.ArrowUpRightIcon)
export const AtSignIcon = icon(Lucide.AtSignIcon)
export const AwardIcon = icon(Lucide.AwardIcon)
export const BackpackIcon = icon(Lucide.BackpackIcon)
export const BellIcon = icon(Lucide.BellIcon)
export const BookOpenTextIcon = icon(Lucide.BookOpenTextIcon)
export const BookTextIcon = icon(Lucide.BookTextIcon)
export const BookmarkIcon = icon(Lucide.BookmarkIcon)
export const BotIcon = icon(Lucide.BotIcon)
export const BugIcon = icon(Lucide.BugIcon)
export const CalendarIcon = icon(Lucide.CalendarIcon)
export const CalendarClockIcon = icon(Lucide.CalendarClockIcon)
export const CameraIcon = icon(Lucide.CameraIcon)
export const CaptionsIcon = icon(Lucide.CaptionsIcon)
export const CarIcon = icon(Lucide.CarIcon)
export const ChartPieIcon = icon(Lucide.ChartPieIcon)
export const CheckIcon = icon(Lucide.CheckIcon)
export const ChevronDownIcon = icon(Lucide.ChevronDownIcon)
export const ChevronLeftIcon = icon(Lucide.ChevronLeftIcon)
export const ChevronRightIcon = icon(Lucide.ChevronRightIcon)
export const ChevronUpIcon = icon(Lucide.ChevronUpIcon)
export const ChevronsRightIcon = icon(Lucide.ChevronsRightIcon)
export const CircleIcon = icon(Lucide.CircleIcon, 'circle')
export const CircleCheckBigIcon = icon(Lucide.CircleCheckBigIcon)
export const CirclePlusIcon = icon(Lucide.CirclePlusIcon)
export const ClapperboardIcon = icon(Lucide.ClapperboardIcon)
export const ClipboardListIcon = icon(Lucide.ClipboardListIcon)
export const ClockIcon = icon(Lucide.ClockIcon)
export const CloudCheckIcon = icon(Lucide.CloudCheckIcon)
export const CodeXmlIcon = icon(Lucide.CodeXml, 'CodeXmlIcon')
export const Columns3Icon = icon(Lucide.Columns3Icon)
export const CompassIcon = icon(Lucide.CompassIcon)
export const CopyIcon = icon(Lucide.CopyIcon)
export const CopyPlusIcon = icon(Lucide.CopyPlusIcon)
export const CornerDownRightIcon = icon(Lucide.CornerDownRightIcon)
export const CrosshairIcon = icon(Lucide.CrosshairIcon)
export const CreditCardIcon = icon(Lucide.CreditCardIcon)
export const CriticalIcon = icon(Lucide.TriangleAlertIcon, 'CriticalIcon')
export const CropIcon = icon(Lucide.CropIcon)
export const DatabaseIcon = icon(Lucide.DatabaseIcon)
export const DownloadIcon = icon(Lucide.DownloadIcon)
export const EarthIcon = icon(Lucide.EarthIcon)
export const EllipsisIcon = icon(Lucide.EllipsisIcon)
export const EllipsisVerticalIcon = icon(Lucide.EllipsisVerticalIcon)
export const ExpandIcon = icon(Lucide.ExpandIcon)
export const ExternalLinkIcon = icon(Lucide.ExternalLinkIcon)
export const EyeIcon = icon(Lucide.EyeIcon)
export const EyeOffIcon = icon(Lucide.EyeOffIcon)
export const FileOutputIcon = icon(Lucide.FileOutputIcon)
export const FileTextIcon = icon(Lucide.FileTextIcon)
export const FlagIcon = icon(Lucide.FlagIcon)
export const FlaskConicalIcon = icon(Lucide.FlaskConicalIcon)
export const FlipHorizontal2Icon = icon(Lucide.FlipHorizontal2Icon)
export const FlipVertical2Icon = icon(Lucide.FlipVertical2Icon)
export const FolderIcon = icon(Lucide.FolderIcon)
export const FolderOpenIcon = icon(Lucide.FolderOpenIcon)
export const FolderPlusIcon = icon(Lucide.FolderPlusIcon)
export const FruitIcon = icon(Lucide.AppleIcon, 'FruitIcon')
export const GalleryVerticalEndIcon = icon(Lucide.GalleryVerticalEndIcon)
export const GiftIcon = icon(Lucide.GiftIcon)
export const GlobeIcon = icon(Lucide.GlobeIcon)
export const GripIcon = icon(Lucide.GripIcon)
export const GripHorizontalIcon = icon(Lucide.GripHorizontalIcon)
export const GripVerticalIcon = icon(Lucide.GripVerticalIcon)
export const HandshakeIcon = icon(Lucide.HandshakeIcon)
export const HashIcon = icon(Lucide.HashIcon)
export const HashtagIcon = icon(Lucide.HashIcon, 'HashtagIcon')
export const HeadingIcon = icon(Lucide.HeadingIcon)
export const HeartIcon = icon(Lucide.HeartIcon)
export const HighlighterIcon = icon(Lucide.HighlighterIcon)
export const HouseIcon = icon(Lucide.HouseIcon)
export const ImageIcon = icon(Lucide.ImageIcon)
export const ImagePlusIcon = icon(Lucide.ImagePlusIcon)
export const InfinityIcon = icon(Lucide.InfinityIcon)
export const InfoIcon = icon(Lucide.InfoIcon)
export const KeyboardIcon = icon(Lucide.KeyboardIcon)
export const LayoutGridIcon = icon(Lucide.LayoutGridIcon)
export const LinkIcon = icon(Lucide.LinkIcon)
export const ListIcon = icon(Lucide.ListIcon)
export const ListOrderedIcon = icon(Lucide.ListOrderedIcon)
export const LockIcon = icon(Lucide.LockIcon)
export const LockOpenIcon = icon(Lucide.LockOpenIcon)
export const LogOutIcon = icon(Lucide.LogOutIcon)
export const MailIcon = icon(Lucide.MailIcon)
export const MapPinIcon = icon(Lucide.MapPinIcon)
export const Maximize2Icon = icon(Lucide.Maximize2Icon)
export const MenuIcon = icon(Lucide.MenuIcon)
export const MessageCircleHeartIcon = icon(Lucide.MessageCircleHeartIcon)
export const MessageSquareIcon = icon(Lucide.MessageSquareIcon)
export const MessagesSquareIcon = icon(Lucide.MessagesSquareIcon)
export const Minimize2Icon = icon(Lucide.Minimize2Icon)
export const MinusIcon = icon(Lucide.MinusIcon)
export const MonitorIcon = icon(Lucide.Monitor, 'MonitorIcon')
export const MonitorSmartphoneIcon = icon(Lucide.MonitorSmartphoneIcon)
export const MoonIcon = icon(Lucide.Moon, 'MoonIcon')
export const MousePointerClickIcon = icon(Lucide.MousePointerClickIcon)
export const MusicIcon = icon(Lucide.MusicIcon)
export const NewspaperIcon = icon(Lucide.NewspaperIcon)
export const OctagonAlertIcon = icon(Lucide.OctagonAlertIcon)
export const PaintBucketIcon = icon(Lucide.PaintBucket, 'PaintBucketIcon')
export const PanelLeftIcon = icon(Lucide.PanelLeftIcon)
export const PanelLeftCloseIcon = icon(Lucide.PanelLeftCloseIcon)
export const PanelLeftOpenIcon = icon(Lucide.PanelLeftOpenIcon)
export const PanelRightCloseIcon = icon(Lucide.PanelRightCloseIcon)
export const PanelRightOpenIcon = icon(Lucide.PanelRightOpenIcon)
export const PawPrintIcon = icon(Lucide.PawPrintIcon)
export const PencilIcon = icon(Lucide.PencilIcon)
export const PickaxeIcon = icon(Lucide.PickaxeIcon)
export const PinIcon = icon(Lucide.PinIcon)
export const PlayIcon = icon(Lucide.PlayIcon)
export const PlusIcon = icon(Lucide.PlusIcon)
export const RadioIcon = icon(Lucide.RadioIcon)
export const Redo2Icon = icon(Lucide.Redo2Icon)
export const RefreshCwIcon = icon(Lucide.RefreshCwIcon)
export const RepeatIcon = icon(Lucide.RepeatIcon)
export const Repeat2Icon = icon(Lucide.Repeat2Icon)
export const RotateCwIcon = icon(Lucide.RotateCwIcon)
export const RssIcon = icon(Lucide.RssIcon)
export const ScanEyeIcon = icon(Lucide.ScanEyeIcon)
export const ScissorsIcon = icon(Lucide.ScissorsIcon)
export const ScrollTextIcon = icon(Lucide.ScrollTextIcon)
export const SearchIcon = icon(Lucide.SearchIcon)
export const SettingsIcon = icon(Lucide.SettingsIcon)
export const ShapesIcon = icon(Lucide.ShapesIcon)
export const Share2Icon = icon(Lucide.Share2Icon)
export const ShirtIcon = icon(Lucide.ShirtIcon)
export const ShoppingCartIcon = icon(Lucide.ShoppingCartIcon)
export const ShuffleIcon = icon(Lucide.ShuffleIcon)
export const SlidersVerticalIcon = icon(Lucide.SlidersVerticalIcon)
export const SmartphoneIcon = icon(Lucide.SmartphoneIcon)
export const SmileIcon = icon(Lucide.SmileIcon)
export const SparklesIcon = icon(Lucide.SparklesIcon)
export const StarIcon = icon(Lucide.StarIcon)
export const SunIcon = icon(Lucide.Sun, 'SunIcon')
export const TagIcon = icon(Lucide.TagIcon)
export const TagPlusIcon = icon(Lucide.TagPlusIcon)
export const TargetIcon = icon(Lucide.TargetIcon)
export const TentTreeIcon = icon(Lucide.TentTreeIcon)
export const TerminalIcon = icon(Lucide.TerminalIcon)
export const ThumbsDownIcon = icon(Lucide.ThumbsDownIcon)
export const ThumbsUpIcon = icon(Lucide.ThumbsUpIcon)
export const TrashIcon = icon(Lucide.TrashIcon)
export const TrendingUpIcon = icon(Lucide.TrendingUpIcon)
export const UploadIcon = icon(Lucide.UploadIcon)
export const UserIcon = icon(Lucide.UserIcon)
export const UserRoundCheckIcon = icon(Lucide.UserRoundCheckIcon)
export const UserRoundPenIcon = icon(Lucide.UserRoundPenIcon)
export const UserRoundPlusIcon = icon(Lucide.UserRoundPlusIcon)
export const VideoIcon = icon(Lucide.VideoIcon)
export const VolleyballIcon = icon(Lucide.VolleyballIcon)
export const VolumeOffIcon = icon(Lucide.VolumeXIcon, 'VolumeOffIcon')
export const WandSparklesIcon = icon(Lucide.WandSparklesIcon)
export const WarningIcon = icon(Lucide.TriangleAlertIcon, 'WarningIcon')
export const ZapIcon = icon(Lucide.ZapIcon)
export const ZoomInIcon = icon(Lucide.ZoomInIcon)
export const ZoomOutIcon = icon(Lucide.ZoomOutIcon)
export const AlignCenterIcon = icon(Lucide.AlignCenterIcon)
export const AlignLeftIcon = icon(Lucide.AlignLeftIcon)
export const AlignRightIcon = icon(Lucide.AlignRightIcon)
export const BoldIcon = icon(Lucide.BoldIcon)
export const Building2Icon = icon(Lucide.Building2Icon)
export const CalendarDaysIcon = icon(Lucide.CalendarDaysIcon)
export const CaseSensitiveIcon = icon(Lucide.CaseSensitiveIcon)
export const ChartColumnIcon = icon(Lucide.ChartColumnIcon)
export const CircleDollarSignIcon = icon(Lucide.CircleDollarSignIcon)
export const CircleHelpIcon = icon(Lucide.CircleHelpIcon)
export const CircleFadingArrowUpIcon = icon(Lucide.CircleFadingArrowUpIcon)
export const ForwardIcon = icon(Lucide.ForwardIcon)
export const Grid3x3Icon = icon(Lucide.Grid3x3Icon)
export const ItalicIcon = icon(Lucide.ItalicIcon)
export const KeyRoundIcon = icon(Lucide.KeyRoundIcon)
export const LayoutDashboardIcon = icon(Lucide.LayoutDashboardIcon)
export const LightbulbIcon = icon(Lucide.LightbulbIcon)
export const Link2OffIcon = icon(Lucide.Link2OffIcon)
export const ListFilterIcon = icon(Lucide.ListFilterIcon)
export const ListTreeIcon = icon(Lucide.ListTreeIcon)
export const LoaderCircleIcon = icon(Lucide.LoaderCircleIcon)
export const MessageCircleIcon = icon(Lucide.MessageCircleIcon)
export const MessageCircleQuestionMarkIcon = icon(
  Lucide.MessageCircleQuestionMarkIcon,
)
export const MessageSquareMoreIcon = icon(Lucide.MessageSquareMoreIcon)
export const MessageSquareQuoteIcon = icon(Lucide.MessageSquareQuoteIcon)
export const Rows3Icon = icon(Lucide.Rows3Icon)
export const SendHorizontalIcon = icon(Lucide.SendHorizontalIcon)
export const SquareKanbanIcon = icon(Lucide.SquareKanbanIcon)
export const SquarePenIcon = icon(Lucide.SquarePenIcon)
export const TriangleAlertIcon = icon(Lucide.TriangleAlertIcon)
export const StrikethroughIcon = icon(Lucide.StrikethroughIcon)
export const Undo2Icon = icon(Lucide.Undo2Icon)
export const UnderlineIcon = icon(Lucide.UnderlineIcon)
export const UsersIcon = icon(Lucide.UsersIcon)
export const XIcon = icon(Lucide.XIcon)
